import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import queryString from 'query-string'
import moment from 'moment-timezone'
import _ from 'lodash';

function getLeadConversions(filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/lead-conversions-analytics/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

function getLeadConversionDays(filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/lead-conversions-analytics/conversion-days/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

function getDistributionFieldQuery(statusValue) {
  if (_.isEmpty(statusValue)) {
    return {
      field: 'status'
    }
  } else {
    return {
      field: 'subStatus',
      status: statusValue
    }
  }
}

function getLeadDistributions(filter, statusValue) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam,
    ...getDistributionFieldQuery(statusValue)
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/lead-conversions-analytics/distributions/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  }).then(r => r.json())
}

function getLeadValueDistributions(filter, statusValue) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam,
    ...getDistributionFieldQuery(statusValue)
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/lead-conversions-analytics/value-distributions/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  }).then(r => r.json())
}

export default {
  getLeadConversions,
  getLeadDistributions,
  getLeadValueDistributions,
  getLeadConversionDays
}



// WEBPACK FOOTER //
// ./src/services/lead-conversions-analytics-service.js